import { render, staticRenderFns } from "./ForecastingByProductFilters.html?vue&type=template&id=37ba91a3&scoped=true&"
import script from "./ForecastingByProductFilters.component.js?vue&type=script&lang=js&"
export * from "./ForecastingByProductFilters.component.js?vue&type=script&lang=js&"
import style0 from "./ForecastingByProductFilters.scss?vue&type=style&index=0&id=37ba91a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba91a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VCombobox,VForm,VRow})
